// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#070908',
          secondary: '#F6D84A',
          background: '#020202',
          surface: '#10100C',
          accent: '#D6B846',
          success: '#D6B846',
          warning: '#F6D84A',
        },
      },
    },
  },
}
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
                             //test
)
